export default {
    title: '<strong>Giáo viên</strong> và <strong>Học sinh</strong> cùng tham gia <strong>Hoạt động buổi học trực tuyến</strong>',
    buttons: {
        teacher: 'Giáo viên bắt đầu buổi học',
        student: 'Học sinh tham gia',
    },
};
